var _path, _symbol, _symbol2, _path2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-appIcon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    style: {
      fill: "var(--color1, #161616)"
    },
    d: "M26.667 0h-21.333c-2.946 0-5.333 2.388-5.333 5.333v0 21.333c0 2.946 2.388 5.333 5.333 5.333v0h21.333c2.946 0 5.333-2.388 5.333-5.333v0-21.333c0-2.946-2.388-5.333-5.333-5.333v0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.331 23.027c0.245-1.271 0.453-2.61 0.747-3.949 0.145-0.7-0.031-0.999-0.815-0.946s-1.657 0.027-2.489 0c-0.833-0.027-0.983-0.446-0.503-1.044 2.363-2.918 4.753-5.8 7.134-8.673 0.267-0.326 0.575-0.557 1.013-0.312 0.44 0.245 0.349 0.549 0.277 0.915-0.263 1.338-0.48 2.677-0.769 3.989-0.149 0.678 0.045 0.919 0.751 0.892 0.318-0.017 0.69-0.027 1.064-0.027s0.746 0.010 1.115 0.029l-0.052-0.002c0.403 0 0.933-0.209 1.141 0.339s-0.231 0.781-0.453 1.107c-1.327 1.642-2.227 2.729-3.135 3.81l0.383-0.468c0.598-0.771-0.727 0.808-2.049 2.39l-2.003 2.464c-0.263 0.317-0.557 0.571-1.005 0.411s-0.353-0.54-0.353-0.924z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "appIcon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "",
    style: {
      fill: "var(--color1, )"
    },
    d: "M25.6 0h-19.2c-3.535 0-6.4 2.865-6.4 6.4v0 19.2c0 3.535 2.865 6.4 6.4 6.4v0h19.2c3.535 0 6.4-2.865 6.4-6.4v0-19.2c0-3.535-2.865-6.4-6.4-6.4v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "",
    style: {
      fill: "var(--color2,)"
    },
    d: "M13.331 23.027c0.245-1.272 0.453-2.61 0.747-3.949 0.144-0.701-0.032-1-0.815-0.946s-1.656 0.027-2.49 0c-0.832-0.026-0.982-0.446-0.502-1.044 2.363-2.918 4.753-5.8 7.134-8.674 0.266-0.326 0.574-0.558 1.014-0.312s0.349 0.549 0.276 0.914c-0.262 1.338-0.48 2.678-0.77 3.989-0.149 0.678 0.046 0.92 0.752 0.893 0.318-0.017 0.689-0.027 1.064-0.027s0.746 0.010 1.115 0.029l-0.052-0.002c0.402 0 0.933-0.21 1.141 0.339s-0.231 0.781-0.453 1.106c-1.328 1.643-2.228 2.73-3.136 3.811l0.384-0.47c-1.361 1.624-2.712 3.242-4.051 4.854-0.262 0.317-0.557 0.571-1.005 0.41s-0.354-0.54-0.354-0.923z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-help-circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333s-5.969-13.333-13.333-13.333-13.333 5.97-13.333 13.333c0 7.364 5.97 13.333 13.333 13.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M12.12 12c0.313-0.891 0.932-1.643 1.747-2.121s1.772-0.654 2.703-0.494c0.931 0.16 1.776 0.644 2.384 1.366s0.941 1.637 0.94 2.582c0 2.667-4 4-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M16 22.667h0.020"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-circle-broken-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4471,
    d: "M5.13 9.725c2.17-3.751 6.225-6.275 10.87-6.275 6.931 0 12.549 5.618 12.549 12.549s-5.618 12.549-12.549 12.549c-4.645 0-8.7-2.523-10.87-6.274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4471,
    d: "M16 21.019l5.020-5.020-5.020-5.020"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4471,
    d: "M3.451 16h17.569"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bell",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#bedbb0",
    style: {
      stroke: "var(--color2, #bedbb0)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M12.472 28c0.94 0.83 2.175 1.333 3.528 1.333s2.588-0.504 3.528-1.333M24 10.667c0-2.122-0.843-4.157-2.343-5.657s-3.535-2.343-5.657-2.343-4.157 0.843-5.657 2.343c-1.5 1.5-2.343 3.535-2.343 5.657 0 4.12-1.039 6.941-2.2 8.807-0.979 1.574-1.469 2.361-1.451 2.58 0.020 0.243 0.071 0.336 0.267 0.481 0.177 0.131 0.974 0.131 2.569 0.131h17.63c1.595 0 2.393 0 2.57-0.131 0.196-0.145 0.247-0.238 0.267-0.481 0.018-0.22-0.472-1.006-1.451-2.58-1.161-1.866-2.2-4.687-2.2-8.807z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-block",
    viewBox: "0 0 32 32"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.143 0h-18.286c-3.787 0-6.857 3.070-6.857 6.857v18.286c0 3.787 3.070 6.857 6.857 6.857h18.286c3.787 0 6.857-3.070 6.857-6.857v-18.286c0-3.787-3.070-6.857-6.857-6.857z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    opacity: 0.1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M21.333 22.857h0.77c0.74 0 1.11 0 1.314-0.154 0.178-0.134 0.288-0.34 0.301-0.562 0.015-0.255-0.19-0.563-0.6-1.179l-2.294-3.44c-0.339-0.509-0.509-0.763-0.722-0.852-0.187-0.078-0.397-0.078-0.584 0-0.214 0.089-0.383 0.343-0.722 0.852l-0.567 0.851M21.333 22.857l-5.855-8.457c-0.337-0.486-0.505-0.729-0.715-0.815-0.184-0.075-0.39-0.075-0.574 0-0.21 0.085-0.379 0.329-0.715 0.815l-4.531 6.544c-0.429 0.62-0.643 0.929-0.631 1.187 0.011 0.224 0.12 0.433 0.298 0.569 0.205 0.157 0.582 0.157 1.335 0.157h11.388zM22.857 11.429c0 1.262-1.023 2.286-2.286 2.286s-2.286-1.023-2.286-2.286c0-1.262 1.023-2.286 2.286-2.286s2.286 1.023 2.286 2.286z"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.5,
    d: "M4 16h24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.5,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.5,
    d: "M4 24h24"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M24 8l-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M8 8l16 16"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-colors",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 27.296c1.415 1.267 3.284 2.037 5.333 2.037 4.418 0 8-3.582 8-8 0-3.689-2.497-6.795-5.893-7.72M8.56 13.614c-3.396 0.925-5.894 4.031-5.894 7.72 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.041-0.199-2.035-0.56-2.947M24 10.667c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8c4.418 0 8 3.582 8 8z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-container",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M27.333 9.704l-11.333 6.296M16 16l-11.333-6.296M16 16l0 12.667M28 21.411v-10.823c0-0.457 0-0.685-0.067-0.889-0.060-0.18-0.157-0.346-0.285-0.485-0.145-0.158-0.345-0.269-0.744-0.491l-9.867-5.481c-0.378-0.21-0.567-0.315-0.767-0.356-0.177-0.036-0.36-0.036-0.537 0-0.2 0.041-0.389 0.146-0.767 0.356l-9.867 5.481c-0.399 0.222-0.599 0.333-0.744 0.491-0.129 0.14-0.226 0.305-0.286 0.485-0.067 0.204-0.067 0.432-0.067 0.889v10.823c0 0.457 0 0.685 0.067 0.889 0.060 0.18 0.157 0.346 0.286 0.485 0.145 0.158 0.345 0.269 0.744 0.491l9.867 5.481c0.378 0.21 0.567 0.315 0.767 0.356 0.177 0.036 0.36 0.036 0.537 0 0.2-0.041 0.389-0.146 0.767-0.356l9.867-5.481c0.399-0.222 0.599-0.333 0.744-0.491 0.129-0.14 0.226-0.305 0.285-0.485 0.067-0.204 0.067-0.432 0.067-0.889z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dashbordicon1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.396 6.978c0.301-1.281 1.301-2.282 2.582-2.582v0c1.11-0.26 2.266-0.26 3.377 0v0c1.281 0.301 2.282 1.301 2.582 2.582v0c0.26 1.11 0.26 2.266 0 3.377v0c-0.301 1.281-1.301 2.282-2.582 2.582v0c-1.11 0.26-2.266 0.26-3.377 0v0c-1.281-0.301-2.282-1.301-2.582-2.582v0c-0.26-1.11-0.26-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.396 21.645c0.301-1.281 1.301-2.282 2.582-2.582v0c1.11-0.261 2.266-0.261 3.377 0v0c1.281 0.3 2.282 1.301 2.582 2.582v0c0.26 1.111 0.26 2.266 0 3.377v0c-0.301 1.281-1.301 2.282-2.582 2.582v0c-1.11 0.261-2.266 0.261-3.377 0v0c-1.281-0.3-2.282-1.301-2.582-2.582v0c-0.26-1.111-0.26-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M19.063 6.978c0.3-1.281 1.301-2.282 2.582-2.582v0c1.111-0.26 2.266-0.26 3.377 0v0c1.281 0.301 2.282 1.301 2.582 2.582v0c0.261 1.11 0.261 2.266 0 3.377v0c-0.3 1.281-1.301 2.282-2.582 2.582v0c-1.111 0.26-2.266 0.26-3.377 0v0c-1.281-0.301-2.282-1.301-2.582-2.582v0c-0.261-1.11-0.261-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M19.063 21.645c0.3-1.281 1.301-2.282 2.582-2.582v0c1.111-0.261 2.266-0.261 3.377 0v0c1.281 0.3 2.282 1.301 2.582 2.582v0c0.261 1.111 0.261 2.266 0 3.377v0c-0.3 1.281-1.301 2.282-2.582 2.582v0c-1.111 0.261-2.266 0.261-3.377 0v0c-1.281-0.3-2.282-1.301-2.582-2.582v0c-0.261-1.111-0.261-2.266 0-3.377v0z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3111,
    d: "M1.333 16c0 0 5.333-10.667 14.667-10.667s14.667 10.667 14.667 10.667c0 0-5.333 10.667-14.667 10.667s-14.667-10.667-14.667-10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3111,
    d: "M16 20c2.209 0 4-1.791 4-4s-1.791-4-4-4c-2.209 0-4 1.791-4 4s1.791 4 4 4z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M29.333 4h-26.667l10.667 12.613v8.72l5.333 2.667v-11.387l10.667-12.613z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-hexagon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M14.964 3.242c0.378-0.21 0.567-0.315 0.767-0.356 0.177-0.036 0.36-0.036 0.537 0 0.2 0.041 0.389 0.146 0.767 0.356l9.867 5.481c0.399 0.222 0.599 0.333 0.744 0.491 0.129 0.14 0.226 0.305 0.285 0.485 0.067 0.204 0.067 0.432 0.067 0.889v10.823c0 0.457 0 0.685-0.067 0.889-0.060 0.18-0.157 0.346-0.285 0.485-0.145 0.158-0.345 0.269-0.744 0.491l-9.867 5.481c-0.378 0.21-0.567 0.315-0.767 0.356-0.177 0.036-0.36 0.036-0.537 0-0.2-0.041-0.389-0.146-0.767-0.356l-9.867-5.481c-0.399-0.222-0.599-0.333-0.744-0.491-0.129-0.14-0.226-0.305-0.286-0.485-0.067-0.204-0.067-0.432-0.067-0.889v-10.823c0-0.457 0-0.685 0.067-0.889 0.060-0.18 0.157-0.346 0.286-0.485 0.145-0.158 0.345-0.269 0.744-0.491l9.867-5.481z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lightning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M18.999 2.667h-7.674c-0.239 0-0.359 0-0.465 0.036-0.093 0.032-0.178 0.085-0.249 0.154-0.080 0.078-0.133 0.185-0.24 0.399l-5.6 11.2c-0.256 0.511-0.383 0.767-0.353 0.974 0.027 0.181 0.127 0.344 0.277 0.449 0.172 0.12 0.458 0.12 1.029 0.12h8.274l-4 13.333 16.258-16.86c0.548-0.569 0.823-0.853 0.839-1.097 0.014-0.211-0.073-0.417-0.235-0.553-0.186-0.157-0.581-0.157-1.372-0.157h-9.49l3-8z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-loading-spin",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.454 22.666c-1.67-2.893-0.821-6.58 1.944-8.453l0.003-0.003c2.221-1.501 5.143-1.45 7.312 0.126l4.576 3.327c2.167 1.576 5.090 1.627 7.312 0.126l0.003-0.003c2.766-1.872 3.616-5.563 1.943-8.453M22.669 27.546c-2.893 1.669-6.58 0.821-8.453-1.944l-0.003-0.003c-1.501-2.221-1.45-5.143 0.126-7.312l3.327-4.576c1.576-2.167 1.627-5.090 0.126-7.312l-0.006-0.003c-1.872-2.763-5.563-3.615-8.453-1.942M25.427 6.572c5.207 5.207 5.207 13.648 0 18.855s-13.648 5.207-18.855 0c-5.207-5.207-5.207-13.648 0-18.855s13.648-5.207 18.855 0z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M11.867 10.080c0.413-4.8 2.88-6.76 8.28-6.76h0.173c5.96 0 8.347 2.387 8.347 8.347v8.693c0 5.96-2.387 8.347-8.347 8.347h-0.173c-5.36 0-7.827-1.933-8.267-6.653"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M2.667 16h17.173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M16.867 11.533l4.467 4.467-4.467 4.467"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M3.333 28.667l7.399-2.846c0.473-0.182 0.71-0.273 0.931-0.392 0.197-0.106 0.384-0.227 0.56-0.364 0.198-0.154 0.378-0.333 0.736-0.692l15.040-15.040c1.473-1.473 1.473-3.861 0-5.333s-3.861-1.473-5.333 0l-15.040 15.040c-0.359 0.359-0.538 0.538-0.692 0.736-0.137 0.176-0.259 0.364-0.364 0.56-0.119 0.221-0.21 0.458-0.392 0.931l-2.846 7.399zM3.333 28.667l2.744-7.135c0.196-0.511 0.295-0.766 0.463-0.883 0.147-0.102 0.329-0.141 0.505-0.107 0.201 0.038 0.395 0.232 0.782 0.619l3.012 3.012c0.387 0.387 0.58 0.58 0.619 0.782 0.034 0.176-0.005 0.358-0.107 0.505-0.117 0.168-0.372 0.267-0.883 0.463l-7.135 2.744z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M25.143 0h-18.286c-3.787 0-6.857 3.070-6.857 6.857v18.286c0 3.787 3.070 6.857 6.857 6.857h18.286c3.787 0 6.857-3.070 6.857-6.857v-18.286c0-3.787-3.070-6.857-6.857-6.857z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M16 11.333v9.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M11.333 16h9.333"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus-black",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144-422.857h381.714c5.049 0 9.143 4.093 9.143 9.143v476.571c0 5.049-4.093 9.143-9.143 9.143h-381.714c-5.049 0-9.143-4.093-9.143-9.143v-476.571c0-5.049 4.093-9.143 9.143-9.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.571-11.429h326.857c5.049 0 9.143 4.093 9.143 9.143v37.714c0 5.049-4.093 9.143-9.143 9.143h-326.857c-5.049 0-9.143-4.093-9.143-9.143v-37.714c0-5.049 4.093-9.143 9.143-9.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.143 0h-18.286c-3.787 0-6.857 3.070-6.857 6.857v0 18.286c0 3.787 3.070 6.857 6.857 6.857v0h18.286c3.787 0 6.857-3.070 6.857-6.857v0-18.286c0-3.787-3.070-6.857-6.857-6.857v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M16 11.334v9.333M11.334 16h9.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M-144-422.286h381.714c4.734 0 8.571 3.838 8.571 8.571v476.571c0 4.734-3.838 8.571-8.571 8.571h-381.714c-4.734 0-8.571-3.838-8.571-8.571v-476.571c0-4.734 3.838-8.571 8.571-8.571z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-puzzle-piece",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l4.8 4.8c3.2-8.4 12.133 0.533 3.733 3.733l4.8 4.8-4.8 4.8c-3.2-8.4-12.133 0.533-3.733 3.733l-4.8 4.8-4.8-4.8c-3.2 8.4-12.133-0.533-3.733-3.733l-4.8-4.8 4.8-4.8c3.2 8.4 12.133-0.533 3.733-3.733l4.8-4.8z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l2.683 6.975c0.376 0.978 0.564 1.466 0.856 1.878 0.259 0.364 0.577 0.683 0.942 0.942 0.411 0.292 0.9 0.48 1.878 0.856l6.975 2.683-6.975 2.683c-0.978 0.376-1.466 0.564-1.878 0.856-0.364 0.259-0.683 0.577-0.942 0.942-0.292 0.411-0.48 0.9-0.856 1.878l-2.683 6.975-2.683-6.975c-0.376-0.978-0.564-1.466-0.856-1.878-0.259-0.364-0.578-0.683-0.942-0.942-0.411-0.292-0.9-0.48-1.878-0.856l-6.975-2.683 6.975-2.683c0.978-0.376 1.466-0.564 1.878-0.856 0.364-0.259 0.683-0.578 0.942-0.942 0.292-0.411 0.48-0.9 0.856-1.878l2.683-6.975z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M12 4h8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M6.667 8l0.801 12.018c0.149 2.231 0.223 3.347 0.588 4.243 0.662 1.627 2.004 2.883 3.672 3.435 0.919 0.304 2.037 0.304 4.273 0.304v0c2.236 0 3.354 0 4.273-0.304 1.668-0.552 3.009-1.808 3.671-3.435 0.365-0.896 0.439-2.012 0.588-4.243l0.801-12.018"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecedfd",
    style: {
      fill: "var(--color5, #ecedfd)"
    },
    d: "M3.765 0h24.471c2.079 0 3.765 1.686 3.765 3.765v24.471c0 2.079-1.686 3.765-3.765 3.765h-24.471c-2.079 0-3.765-1.686-3.765-3.765v-24.471c0-2.079 1.686-3.765 3.765-3.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M21.49 14.745c0 2.946-2.388 5.333-5.333 5.333s-5.333-2.388-5.333-5.333c0-2.946 2.388-5.333 5.333-5.333s5.333 2.388 5.333 5.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M29.060 32.853c0-1.723-0.339-3.429-0.999-5.020s-1.626-3.038-2.844-4.256c-1.218-1.218-2.664-2.184-4.256-2.844s-3.297-0.999-5.020-0.999c-1.723 0-3.429 0.339-5.020 0.999s-3.038 1.626-4.256 2.844c-1.218 1.218-2.184 2.664-2.844 4.256s-0.999 3.297-0.999 5.020h26.237z"
  })), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.059 21.082c-.376 0-.753-.188-.941-.376l-7.529-7.529c-.565-.565-.565-1.318 0-1.882s1.506-.565 2.071 0l6.4 6.4 6.588-6.4c.565-.565 1.506-.565 2.071 0s.565 1.506 0 2.071l-7.529 7.529c-.376.188-.753.188-1.129.188z",
    opacity: 0.8
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-avatar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.412 14.824a5.412 5.412 0 1 1-10.824 0 5.412 5.412 0 0 1 10.824 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.471c-3.106 0-5.647-2.541-5.647-5.647S12.894 9.177 16 9.177c3.106 0 5.647 2.541 5.647 5.647S19.106 20.471 16 20.471zm0-10.824c-2.871 0-5.176 2.306-5.176 5.176S13.13 19.999 16 19.999s5.176-2.306 5.176-5.176S18.87 9.647 16 9.647z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 32c.471-6.824 6.165-12.235 13.129-12.235S28.988 25.177 29.458 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.271 32c-.471-6.729-6.165-12-12.894-12-6.776 0-12.471 5.271-12.941 12l-.471-.047c.471-6.965 6.353-12.471 13.365-12.471s12.894 5.459 13.365 12.471l-.424.047z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus-fill",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 26.88c-.96 0-1.6-.64-1.6-1.6V6.72c0-.96.64-1.6 1.6-1.6s1.6.64 1.6 1.6v18.56c0 .96-.64 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.28 17.6H6.72c-.96 0-1.6-.64-1.6-1.6s.64-1.6 1.6-1.6h18.56c.96 0 1.6.64 1.6 1.6s-.64 1.6-1.6 1.6z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.30a2764323c56fcc9b43c1879afc5c4e.svg";
export { ForwardRef as ReactComponent };